import { action } from '@reatom/framework'

import { pipe, Result } from '@blade/std-lib'
import { walletsModelAtom } from '@root/entities/wallet'
import { dependenciesAtom } from '@root/features/shared/dependencies'
import { ApiError, apiRequest } from '@root/shared/api'
import { reatomRequest } from '@root/shared/lib'
import { showErrorSnackbarAction } from '@root/shared/ui/error-snackbar'

import type { WalletId } from '@root/entities/wallet'

export const refreshWalletRequestAction = action(
  async (ctx, walletId: WalletId) => {
    const { tradeApiClient } = ctx.get(dependenciesAtom)

    const result = await ctx.schedule(async () =>
      apiRequest(ctx, tradeApiClient.wallet.walletRefreshBalanceCreate, [
        { walletId },
      ]),
    )
    return pipe(result, Result.mapError(ApiError.fallbackToUnknown))
  },
  'refreshWalletRequestAction',
)

export const reatomRefreshWallet = ({ walletId }: { walletId: WalletId }) => {
  const refreshRequestAtom = reatomRequest({
    execAction: refreshWalletRequestAction,
    // eslint-disable-next-line @reatom/unit-naming-rule
    name: `reatomRefreshWallet_${walletId}`,
    prepare: (_) => walletId,
    onResult: (ctx, result) => {
      if (Result.isSuccess(result)) {
        const model = ctx.get(walletsModelAtom)
        model.upsert(ctx, result.success)
      }

      if (Result.isFailure(result)) {
        showErrorSnackbarAction(ctx, result.failure)
      }
    },
  })

  return refreshRequestAtom
}
